<div class="doc-content">
  <ng-content></ng-content>
</div>
